import { Button, Center, Stack, Text, Title } from "@mantine/core";
import { Link } from "react-router-dom";
import { entityListPath } from "@/routes/paths";

export function NotFoundPage() {
  return (
    <Center mih="60vh">
      <Stack align="center" gap="sm">
        <Title order={1}>404</Title>
        <Text c="dimmed">That screen doesn't exist.</Text>
        <Button component={Link} to={entityListPath("user")} variant="light">
          Back to users
        </Button>
      </Stack>
    </Center>
  );
}
